
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { MortgageData } from "../../CalculatorTabs";
import { calculateMortgageData } from "@/utils/calculator/mortgageCalculator";
import { AutoCalculateOptions } from "../../utils/types";

interface VAStatusSelectProps {
  mortgageData: MortgageData;
  setMortgageData: React.Dispatch<React.SetStateAction<MortgageData>>;
  autoCalculate: AutoCalculateOptions;
}

const VAStatusSelect: React.FC<VAStatusSelectProps> = ({ 
  mortgageData, 
  setMortgageData,
  autoCalculate 
}) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">VA Status</Label>
      <Select 
        value={mortgageData.vaStatus || ""}
        onValueChange={(value: "activeDuty" | "separatedRetired") => {
          setMortgageData(prev => {
            const updatedData = {
              ...prev,
              vaStatus: value
            };
            return calculateMortgageData(updatedData);
          });
        }}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="activeDuty">Active Duty</SelectItem>
          <SelectItem value="separatedRetired">Separated/Retired</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default VAStatusSelect;
